import React, { useEffect, useState, useCallback } from "react";
import { Row, Col } from "react-bootstrap";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { FiSettings } from "react-icons/fi";
import { FaRegPlusSquare } from "react-icons/fa";
import { GoGithubAction } from "react-icons/go";
import { Link } from "react-router-dom";
import { MdHistory } from "react-icons/md";
import { SetGlobalPermission } from "app/Components/SetPermission/Permissions";
import { connect } from "react-redux";
import { getAllCapas } from "app/_services/ehs/ehsCapaServices";
import { ACTIVE_MODULE } from "app/_constants/constant";
import { getLoggedInUserId, isUserMM } from "../IncidentManagement/Helper";
import { capaStatuses } from "../IncidentManagement/CONSTANTS";
import { isUserVFLOfficer } from "../IncidentManagement/Helper";
import { isUserSO } from "../IncidentManagement/Helper";
const CapaManagement = ({
  match: {
    params: { siteId },
  },
  user,
}) => {
  const [capas, setCapas] = useState([]);
  const [capaCount, setCapaCount] = useState(0);
  const ehsPermissions = JSON.parse(user.ehsPermissions || "{}");

  const capasList = useCallback(() => {
    getAllCapas(siteId ? `filter[siteId]=${siteId}` : "").then((response) => {
      if (!response?.data) return;
      setCapas(
        response.data.map((data, index) => {
          return {
            ...data,
            sid: index + 1,
            formattedCompletionProof: !!data?.completionProof
              ? data?.completionProof?.real_document_name
              : "",
            capaStatus: data?.reverted ? "Returned" : data?.capaStatus,
          };
        })
      );
    });
  }, [siteId]);

  useEffect(() => {
    capasList();
  }, [capasList]);

  //count for my capa and capa
  useEffect(() => {
    let viewCapa = capas.length;
    let capaHistory = 0;
    let MyCapa = 0;

    capas.forEach((row) => {
      if (
        getLoggedInUserId() === row?.ownerId &&
        row.capaStatus === capaStatuses.completed
      ) {
        capaHistory++;
      }
      if (
        getLoggedInUserId() === row?.ownerId &&
        row.capaStatus !== capaStatuses.completed
      ) {
        MyCapa++;
      }
    });

    let isCount = 0;
    let vflCount = 0;
    let incidentCount = 0;
    if (isUserVFLOfficer())
      vflCount = capas.filter(
        (row) => row?.source === "ehs_vfl_observations" && row?.reverted
      )?.length;

    if (isUserSO() || isUserMM())
      incidentCount = capas.filter(
        (row) => row?.source === "Incident Management" && row?.reverted
      )?.length;
    isCount = vflCount + incidentCount;

    setCapaCount(capaHistory + viewCapa + isCount + MyCapa);
  }, [capas]);

  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          { name: "CAPA Management", path: "/health-safety-and-environment/vfl" },
        ]}
        module={ACTIVE_MODULE.capa}
      />
      <div className="manageBtnScreen">
        <Row>
          {/* {(!ehsPermissions.restrictCapaAddition || +user.role.roleLable === 1 || +user.role.roleLable === 2) && (
                        <Col lg={4}>
                            <Link to={(siteId ? `/sites/${siteId}` : "") + "/health-safety-and-environment/capa-management/manage-capa/add"} className="btn manage-btn">
                                <FaRegPlusSquare />
                                Add CAPA
                            </Link>
                        </Col>
                    )} */}
          {/* <SetGlobalPermission
            permission={["investigator", "reviewer", "closer"]}
            data={ */}
          <Col lg={4}>
            <Link
              to={
                (siteId ? `/sites/${siteId}` : "") +
                "/health-safety-and-environment/capa-management/manage-capa"
              }
              className="btn manage-btn"
            >
              <GoGithubAction />
              Manage CAPA ({capaCount})
            </Link>
          </Col>
          {/* }
          /> */}
          {/* <Col lg={4}>
            <Link
              to={
                (siteId ? `/sites/${siteId}` : "") +
                "/health-safety-and-environment/capa-management/my-capa"
              }
              className="btn manage-btn"
            >
              <MdHistory /> My CAPA
            </Link>
          </Col> */}
        </Row>
      </div>
    </div>
  );
};

export default connect((state) => ({ user: state.user.user }))(CapaManagement);
